/**
 * Menu navigation that has line on bottom which moves based on hover or selection
 *
 * Example of HTML Code:
 *  <nav class="opui-navigation">
 *      <ul>
 *          <li>
 *              <a href="">
 *                  <i class="opui-fa opui-fa-icon"></i>
 *                  <span>Dashboard</span>
 *              </a>
 *          </li>
 *      </ul>
 *      <span class="opui-navigation-hover"></span>
 *  </nav>
 */

import Emitter from 'es6-event-emitter';
import $ from 'jquery';

export default class MovingBorderMenu extends Emitter {
    constructor(selector = '.ops-secondary-menu, .ops_movingBorderMenu, .opui-navigation', options = {}) {
        super();

        let defaultOptions = { 
            // preventDefault click event on navigation anchor (ul > li > a)
            preventClick: false,      
            // Selector for animated part of active navigation link
            movingBorderSelector: '.ops-secondary-menu-hover, .opui-navigation-hover, .opf_movingBorderMenuHover ',
            // Selected item selector
            activeItemSelector: '.selected, .ops-active, .active',
        }

        this.selector = selector;
        this.options = { ...defaultOptions, ...options };

        this.$movingBorderMenu = null;
        this.$movingBorderMenuHover = null;

        let _this = this;
        $(() => {
            _this.$movingBorderMenu = $(_this.selector);
            _this.$movingBorderMenuHover = _this.$movingBorderMenu.find(_this.options.movingBorderSelector);

            const resizeObserver = new ResizeObserver(() => {
                _this.setPosition();
            });
            _this.$movingBorderMenu.each((index, element) => {
                resizeObserver.observe(element);
            });
        
            _this.$movingBorderMenu
                .find('li')
                    .on("mouseenter", _this.navItemMouseEnterHandler.bind(_this))
                    .on("mouseleave", _this.navItemMouseLeaveHandler.bind(_this))
                .find('a')
                    .on("click", _this.navAnchorClickHandler.bind(_this));
        });
    }

    /**
     * Navigation item mouse enter event handler.
     * 
     * @param {Object} e 
     * @return {Void}
     */
    navItemMouseEnterHandler(e) {
        let $this = $(e.currentTarget);
        let width = $this.width();
        let paddingLeft = parseInt($this.css('paddingLeft'));
        let marginLeft = parseInt($this.css('marginLeft'));
        let left = $this.position().left +  paddingLeft + marginLeft;

        this.$movingBorderMenuHover.css('width', width);
        this.$movingBorderMenuHover.css('left', left);

        if ($this.parent().parent().hasClass('opf_funnelNewPageFilter')) {
            this.$movingBorderMenuHover.css('top', $this.position().top + 43);
        }
    }

    /**
     * Navigation item mouse leave event handler.
     * 
     * @param {Object} e 
     * @return {Void}
     */
    navItemMouseLeaveHandler(e) {
        this.$movingBorderMenuHover.css('width', parseFloat(this.$movingBorderMenuHover.attr('data-width')));
        this.$movingBorderMenuHover.css('left', parseFloat(this.$movingBorderMenuHover.attr('data-left')));
    }

    /**
     * Navigation anchor (link) click event handler.
     * 
     * @param {Object} e 
     * @return {Void}
     */
    navAnchorClickHandler(e) {
        if (this.preventClick) {
            e.preventDefault();
        }

        let $target = $(e.currentTarget).parent('li');

        this.$movingBorderMenu.find('li').removeClass('selected ops-active active');
        $target.addClass('selected ops-active active');

        if (!$target.hasClass('op3_menuNoSelect')) {
            let width = $target.width();
            let $active = this.$movingBorderMenu.find(this.options.activeItemSelector);
            let paddingLeft = parseFloat($active.css('paddingLeft'));
            let marginLeft = parseFloat($active.css('marginLeft'));
            let left = $target.position().left + paddingLeft + marginLeft;

            this.$movingBorderMenuHover.attr('data-width', width);
            this.$movingBorderMenuHover.attr('data-left', left);
        }

        this.trigger('movingBorderMenu:change', $target);
    }

    /**
     * Set initial position based on selected menu point.
     *
     * @return {Void}
     */
    setPosition() {
        let left = 0;
        let width = 0;
        let $active = this.$movingBorderMenu.find(this.options.activeItemSelector);
        let paddingLeft = parseFloat($active.css('paddingLeft'))
        let marginLeft = parseFloat($active.css('marginLeft'))

        if ($active.length > 0) {
            width = $active.width();
            left = $active.position().left + paddingLeft + marginLeft;
        }

        this.$movingBorderMenuHover.attr('data-width', width).css('width', parseFloat(this.$movingBorderMenuHover.attr('data-width')));
        this.$movingBorderMenuHover.attr('data-left', left).css('left', parseFloat(this.$movingBorderMenuHover.attr('data-left')));
    }


    /**
     * Change menu point based on index
     *
     * @param {int} index
     */
     changeMenu(index) {
        if (this.$movingBorderMenu === null) {
            return;
        }

        index = parseInt(index) + 1;

        this.$movingBorderMenu.find('li').removeClass('selected').removeClass('ops-active');
        this.$movingBorderMenu.find('li:nth-child(' + index + ')').addClass('selected').addClass('ops-active');
        this.$movingBorderMenu.find('li.selected, li.ops-active').trigger('mouseover');
    }

}
